import React, { useState, useEffect, useLayoutEffect, useRef } from 'react'
import { Row, Col, Button, Select, Form, Input, Checkbox } from 'antd'
import { connect } from 'react-redux'
import TableComponent from 'components/Table'
import SelectField from 'components/SelectField'
import SortableColumn from 'components/Table/ColumnSort'
import SearchableColumn from 'components/Table/ColumnSearch'
import TransferInputs from './TransferInputs'
import TransferBottom from './TransferBottom'
import CustomTooltip from 'components/Tooltip'
import Modal from 'components/Modal'

import { checkAmountForRequest, resetForm } from '../../../../services/helper'
import { EditIco } from '../../../../../modules/CustomIcons'
import { useLocation, useHistory } from 'react-router-dom'

import {
  TabsInfoIco,
  NoticeIco,
  NoticeLinedIco,
  NoticeLineReddIco,
} from '../../../../../modules/CustomIcons'

import './index.scss'
import '../Transfer/index.scss'
import '../../../Transfer/transfer.scss'

import successStatus from 'assets/images/icons/successStatus.svg'
import errorStatus from 'assets/images/icons/errorStatus.svg'
import checkedStatus from 'assets/images/icons/checkedStatus.svg'

import { getCurrentCompany } from '../../../../services/user'
import { checkSalaryList } from '../../../../services/salary'
import { getSalaryDocumentNumber } from '../../../../services/salary'
import { financial } from '../../../../services/helper'
import {
  setTableDataSalary,
  setSelectedOption,
  editTableDataSalary,
  createTransferSalary
} from 'store/actions/salary'
import { getAccounts, Account } from '../../../../services/account'
import { SelectOptions } from '../../../../services/form'
import { useActions } from '../../../../hooks/useActions'
import { postSalaryData } from '../../../../services/salary'
import FullScreenLoading from 'components/FullScreenLoading'
import { useTranslation } from 'react-i18next'
import { useConveyer } from "@egjs/react-conveyer";


const pageOptions = [10, 50, 100]


const Transfer: React.FC<any> = ({
  tableData,
  editedTableValue,
  tableValue,
  createdTransferValue
}) => {
  const {t} = useTranslation()
  const ref = useRef<HTMLDivElement>(null);
    useConveyer(ref, {
      horizontal: true,
  });
  const modalDataInitial = {
    modalTitle: t("home.salary"),
    groups: [
      {
        title: false,
        data: [],
      },
    ],
    // pdfFiles: [],
    buttons: [{ save: true }, { sign: true }, { approve: true }, { send: true }],
  }
  const statusOptions = [
    {
      label: t("common.all"),
      value: 'all',
    },
    {
      label: t("salary.checked"),
      value: 'checked',
    },
    {
      label: t("salary.thereIsError"),
      value: 'errored',
    },
  ]

  const [pageSize, setPageSize] = useState(10)
  const [status, setStatus] = useState(t("salary.checked"))
  const [checkError, setCheckError] = useState(true)
  const [filteredData, setFilteredData] = useState([])
  const [filteredDataForSort, setFilteredDataForSort] = useState([])
  const [isFilterd, setIsFiltered] = useState(false)
  const [nextModalVisible, setNextModalVisible] = useState(false)
  const [fromBranch, setFromBranch] = useState<Account>()
  const [modalData, setModalData] = useState(modalDataInitial)
  const [allAccounts, setAllAccounts] = useState<Account[]>()
  const [fromSelectOptions, setFromSelectOptions] = useState<SelectOptions[]>()
  const [documentNumber, setDocumentNumber] = useState<string>('')
  const [toSelectOptions, setToSelectOptions] = useState<SelectOptions[]>()
  const { setSelectedOption, editTableDataSalary, setTableDataSalary, createTransferSalary } =
    useActions()
  const [erroredIndex, setErroredIndex] = useState([])
  const [errorCount, setErrorCount] = useState([])
  const [checkResult, setCheckResult] = useState([])
  const [checkResultSuccess, setCheckResultSuccess] = useState([])
  const [employeData, setEmployeData] = useState([])
  const [hasError, setHasError] = useState(true)
  const [repeatAcc, setRepeatAccount] = useState([])
  const [textAreaModal, setTextVisibleModal] = useState(false)
  const [notice, setNotice] = useState(undefined)
  const [editRecord, setEditRecord] = useState('')
  const [defaultNote, setDefaultNote] = useState('')
  const [newRecord, setNewRecord] = useState('')
  const [showSpinner, setShowSpinner] = useState<boolean>(false)
  const [selectedRowKeys, setCheckedList] = useState([])
  const [checkResultData, setCheckResultData] = useState([])
  const [isChekded, setIsChecked] = useState(true)
  const [current, setCurrent] = useState(1)
  const [symbolCount, setSymbolCount] = useState<number>(180)
  const [isRowAdded, setAdded] = useState(false)
  const [paste, setPaste] = useState(true)
  const [copiedData, setCopiedData] = useState('')
  const [form] = Form.useForm()
  const { TextArea } = Input
  const specialCharRegexRu = new RegExp('[а-яА-ЯЁё!@-]')
  const specialCharRegex = new RegExp(
    /[`~!@#$%^&*_|«»+\-=?;:'"<>\{\}\[\]\\\/]/gi
  )
  const [ibankRef, setIbankRef] = useState<string>('');
  const [maindet,setMainDet] = useState<any>('')
  const location = useLocation()
  const history = useHistory()
  const fetchData = async () => {
    const data = await getAccounts(getCurrentCompany())
    let temp_data: Array<any> = []
    for (let row of data) {
      // @ts-ignore
      if (row.CCY_NAME == 'AZN' && row.STATUS !== '0' && row?.PRODUCT_CODE !== "140110" && row?.PRODUCT_CODE !== "140111") {
        temp_data.push({
          label: row.NICKNAME ? row.NICKNAME : row.IBAN,
          value: row.IBAN,
          extra: `${financial(row.BALANCE_LC) ? financial(row.BALANCE_LC) : ''
            } ${row.CCY_NAME}`,
        })
      }
    }
    setAllAccounts(data)
    setFromSelectOptions((old_data) => temp_data)
  }

  const newTransferFunc = async (RequestType: string) => {
    let temp_dataXls = []
    let detail= form.getFieldValue('PMTDETAIL') !== undefined ? form.getFieldValue('PMTDETAIL'):''
    // let dataArr = uploadedFile.splice(3)
    let values = ibankRef ? {
      trnRequestType: RequestType,
      PMTCUSTID: form.getFieldValue('PMTCUSTID'),
      CUSTACC: form.getFieldValue('CUSTACC'),
      PMTAMOUNT: checkAmountForRequest(form.getFieldValue('PMTAMOUNT')),
      CUSTACCFORCOM: form.getFieldValue('CUSTACCFORCOM'),
      PMTTYPECODE: 'SP',
      COMMAMOUNT: checkAmountForRequest(form.getFieldValue('COMMISSION')) ?? '',
      NOTE: notice ? notice : form.getFieldValue('NOTE'),
      PMTDET: form.getFieldValue('MAINDET')+" "+ detail,
      BENEFACC: form.getFieldValue('CUSTACC'),
      ibankRef: ibankRef,
      mainDetail:form.getFieldValue('MAINDET')

    } : {
      trnRequestType: RequestType,
      PMTCUSTID: form.getFieldValue('PMTCUSTID'),
      CUSTACC: form.getFieldValue('CUSTACC'),
      PMTAMOUNT: checkAmountForRequest(form.getFieldValue('PMTAMOUNT')),
      CUSTACCFORCOM: form.getFieldValue('CUSTACCFORCOM'),
      PMTTYPECODE: 'SP',
      COMMAMOUNT: checkAmountForRequest(form.getFieldValue('COMMISSION')) ?? '',
      NOTE: notice ? notice : form.getFieldValue('NOTE'),
      PMTDET:form.getFieldValue('MAINDET')+" "+ detail,
      BENEFACC: form.getFieldValue('CUSTACC'),
      mainDetail:form.getFieldValue('MAINDET')
    }

    for (let row of editedTableValue) {
      const emp_line = employeData.find(c => c.EMPLACC == row.account)
      // @ts-ignore

      temp_dataXls.push({
        xref: row.key,
        employeeNumber: isNaN(row.amount) ? 0 : row.amount,
        employeeName: emp_line !== undefined ? emp_line['EMPLNAME'] : "",
        employeeAccount: row.account,
        employeeAmount: isNaN(row.amount) ? 0 : row.amount,
        employeePmtDetail:  form.getFieldValue('MAINDET')+" "+ detail,
        employeePmtNote: row.notification,
      })
    }
    let postData = Object.assign(values, { TRANSACTION_EMPLIST: temp_dataXls })
    const data = await postSalaryData(postData)
   
      if(data?.status==="SUCCESS") {
      // editTableDataSalary([])
      resetForm
      }

    
    return data
  }

  useEffect(() => {
    fetchData()
  }, [])

  useLayoutEffect(() => {
    if (editedTableValue.length == 0) {
      setErrorCount([])
      setErroredIndex([])
    }
  }, [editedTableValue.length])


  const validateAccount = (data: any) => {
    let errAccIndex: Array<any> = []
   
    const filteredAccount = data.filter((row: any) => {
      if (
        (row['account'] &&
          (!row['account'].includes('BRES') || row['account'].length !== 28)) ||
        !row['account']
      ) {
        errAccIndex.push(row.account)
        return errAccIndex
      }
    })

    return filteredAccount
  }

  useEffect(() => {
    if (editedTableValue.length && !validateAccount(editedTableValue).length) {
      checkSalary()
    }
  }, [editedTableValue.length])

  const updateToSelectOption = (findAccount: string) => {
    const data = allAccounts?.filter(
      (row) =>
        row.CCY_NAME == findAccount?.CCY_NAME && row.IBAN != findAccount?.IBAN
    )
    let temp_data = []
    for (let row of data) {
      // @ts-ignore
      temp_data.push({
        label: row.NICKNAME ? row.NICKNAME : row.IBAN,
        value: row.IBAN,
        extra: row.CCY_NAME,
      })
    }
    setToSelectOptions(() => temp_data)
  }

  const updateDocumentNumber = async () => {
    const document_number = await getSalaryDocumentNumber(getCurrentCompany())
    form.setFieldsValue({ PMTCUSTID: document_number })
    setDocumentNumber(() => document_number)
  }

  const getSelectedFromBranch = (value: any) => {
    const findAccount = allAccounts?.find((row) => row.IBAN == value)
    if (findAccount?.STATUS !== '0') {
      setFromBranch(findAccount)
    }

    updateToSelectOption(findAccount)
    setSelectedOption(findAccount.IBAN)

    // findUserByIban('');
    if (!form.getFieldValue('PMTCUSTID')) {
      updateDocumentNumber()
    }
  }

  const handleNotChange = (record: any, text: string) => {
    setEditRecord(record)
    setDefaultNote(text)
    if (text) {
      if (text.length < 180) {
        setSymbolCount(180 - text.length)
      } else {
        setSymbolCount(0)
      }
    }
    setTextVisibleModal(true)
  }

  const handleTextAreaChange = (e: any) => {
    if (!specialCharRegexRu.test(e.target.value)) {
      const result = e.target.value.replace(/[а-яА-ЯЁё!@-]/gi, '')
      setNotice(result)
      setDefaultNote(result)
    } else {
      setNotice(e.target.value)
      setDefaultNote(e.target.value)
    }
  }

  const handleTextEdit = () => {
    if (notice !== undefined) {
      const newData = [...editedTableValue]
      const index = newData.findIndex((item) => editRecord.key === item.key)
      const item = newData[index]
      newData.splice(index, 1, { ...item, ...{ notification: notice } })
      editTableDataSalary(newData)
    }
    setTextVisibleModal(false)
    // setDefaultNote('')
    // setNotice('')
  }

  const [filtereValues, setFilteredValues] = useState({
    col_2: '',
    col_3: '',
    col_4: '',
    col_5: '',
    col_6: '',
    col_8: '',
  })

  const handleFilterColumn = (e: any, column: string) => {
    let newfiltereValues = filtereValues

    if (column === 'name') {
      newfiltereValues.col_2 = e.target.value?.toLowerCase()
      setFilteredValues(newfiltereValues)
    }

    if (column === 'owner') {
      newfiltereValues.col_3 = e.target.value?.toLowerCase()
      setFilteredValues(newfiltereValues)
    }

    if (column === 'account') {
      newfiltereValues.col_4 = e.target.value?.toLowerCase()
      setFilteredValues(newfiltereValues)
    }

    if (column === 'amount') {
      newfiltereValues.col_5 = e.target.value?.toLowerCase()
      setFilteredValues(newfiltereValues)
    }

    if (column === 'description') {
      newfiltereValues.col_6 = e.target.value?.toLowerCase()
      setFilteredValues(newfiltereValues)
    }

    if (column === 'status') {
      newfiltereValues.col_8 = e?.toLowerCase()
      setFilteredValues(newfiltereValues)
    }

    if (editedTableValue && filtereValues) {
      let filteredData
      filteredData = editedTableValue?.filter(
        (sRow) =>
          sRow?.name
            .toLowerCase()
            .normalize()
            .replace(/[\u0300-\u036f]/g, '')
            .includes(filtereValues['col_2']) &&
          sRow?.owner
            ?.toString()
            .toLowerCase()
            .normalize()
            .replace(/[\u0300-\u036f]/g, '')
            .includes(filtereValues['col_3']) &&
          sRow?.account
            ?.toString()
            .toLowerCase()
            .normalize()
            .replace(/[\u0300-\u036f]/g, '')
            .includes(filtereValues['col_4']) &&
          sRow?.amount
            ?.toString()
            .toLowerCase()
            .normalize()
            .replace(/[\u0300-\u036f]/g, '')
            .includes(filtereValues['col_5']) &&
          sRow?.description
            .toLowerCase()
            .normalize()
            .replace(/[\u0300-\u036f]/g, '')
            .includes(filtereValues['col_6']) &&
          sRow.status.toLowerCase().includes(filtereValues['col_8'])
      )

      setFilteredData(filteredData)
      setFilteredDataForSort(filteredData)
      setIsFiltered(true)
      setCurrent(1)

      if (filtereValues['col_8'] === 'all' || !e.target.value) {
        form.resetFields(['status_filter'])
      }
    }

    // const filteredData = editedTableValue?.filter((item: any) => {
    //   //@ts-ignorets-ignore
    //   return item[column]
    //     .toLowerCase()
    //     .includes(event.target.value.toLowerCase())
    // })
    // setFilteredData(filteredData)
    // setIsFiltered(true)
  }

  const columnsData = [
    {
      title: (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <SortableColumn
            data={isFilterd ? filteredData : editedTableValue}
            setData={setFilteredData}
            dataOriginal={filteredDataForSort}
            setDataOriginal={setFilteredDataForSort}
            isFiltered={isFilterd}
            setIsFiltered={setIsFiltered}
            type={'index'}
            parameter={'number'}
          />
          №
        </div>
      ),
      width: 20,
      ellipsis: true,
      editable: false,
      dataIndex: 'number',
      key: 'number',
      type: '',
      // sorter: (a: any, b: any) => a.key - b.key,
      render: (record: any, text: any, index: number) => {
        return <p style={{ position: 'relative', right: 5 }}>{record}</p>
      },
    },
    {
      title: (
          <div className="searchable-column">
            <div className={'flex transferSorter'}>
              <Form
                  form={form}
                  className={"transfer-form"}
              >
                <SearchableColumn
                    large
                    title={t("salary.employeeName")}
                    form={form}
                    name={'name'}
                    filter={'searchfilter'}
                    onChange={(event: any) => handleFilterColumn(event, 'name')}
                />
              </Form>
              {/* <SearchableColumn title={'Alan'} /> */}
            </div>
          </div>
      ),
      dataIndex: 'name',
      key: 'name',
      width: 130,
      ellipsis: true,
      editable: false,
      // sorter: (a: any, b: any) => a.getter.localeCompare(b.getter),
      render: (text: string, record: any) => {
        return (
            <div>
              {' '}
              {text?.length > 19 ? (
                  <CustomTooltip title={text}>
                    <p>{text}</p>
                  </CustomTooltip>
              ) : (
                  <p>{text}</p>
              )}
            </div>
        )
      },
    },
    {
      title: (
          <div className="searchable-column">
            <div className={'flex transferSorter'}>
              <Form form={form}  className={"transfer-form"}>
                <SearchableColumn
                  large
                  title={t("salary.accountHolder")}
                  form={form}
                  name={'owner'}
                  filter={'searchfilter'}
                  onChange={(event: any) => handleFilterColumn(event, 'owner')}
                />
              </Form>
            </div>
          </div>
      ),
      dataIndex: 'owner',
      key: 'owner',
      editable: false,
      width: 130,
      ellipsis: true,
      render: (text: string, record: any, index: number) => {
        if (employeData && employeData.some((e) => e.EMPLACC === record.account)) {
          const employee = employeData.find((e) => e.EMPLACC === record.account);
          return <p>{employee.EMPLNAME}</p>;
        } else {
          return <p>{text}</p>; // Render 'owner' or default text if no match found
        }
      },
    },
    {
      title: (
          <div className="searchable-column">
            <div className={'flex transferSorter'}>
              <Form form={form} className={"transfer-form"}>
                <SearchableColumn
                  large
                  title={t("salary.employeeAccountNumber")}
                  form={form}
                  name={'account'}
                  filter={'searchfilter'}
                  onChange={(event: any) => handleFilterColumn(event, 'account')}
                />
              </Form>
            </div>
          </div>
      ),
      dataIndex: 'account',
      key: 'account',
      editable: true,
      placeholder: t("salary.employeeAccountNumber"),
      width: 240,
      ellipsis: true,
      rules: [{ required: true, message: 'Please input your username!' }],
      render: (text: string, record: any, index: number) => {
        if (text !== '' && text !== undefined && text !== ' ') {
          // if(text) {
          if (
            text &&
            (text.length !== 28 ||
              !text.includes('BRES') ||
              (checkResult.length > 0 && checkResult.includes(text)))
          ) {
            return (
              <div className="editable-cell-value-wrap--errored editable-cell-value-wrap--errored__salary" style={{ width: '240px'}}>
                <p>{text !== '' ? text : ''}</p>
              </div>
            )
          } else {
            return (
              <div className="editable-cell-value-wrap editable-cell-value-wrap__salary" style={{ width: '240px'}}>
                <p style={{ maxWidth: 240 }}>{text}</p>
              </div>
            )
          }
          // }
        } else {
          return (
            <div className="editable-cell-value-wrap__added editable-form-item__added" style={{ width: '240px'}}>
              <p className="editable-form-item__input editable-form-item__input--bordered">
                <p className="child_placeholder">{t("salary.employeeAccountNumber")}</p>
                {text}
              </p>
              <EditIco />
            </div>
          )
        }
      },
    },
    {
      title: (
       <div className="searchable-column" style={{width: "100px"}}>
          <div className={'flex transferSorter'}>
            <SortableColumn />
            <Form form={form} className={"transfer-form"}>
              <SearchableColumn
                medium
                title={t("common.amount")}
                form={form}
                name={'amount'}
                filter={'searchfilter'}
                onChange={(event: any) => handleFilterColumn(event, 'amount')}
              />
            </Form>
          </div>
        </div>
      ),
      dataIndex: 'amount',
      key: 'amount',
      editable: true,
      placeholder: t("common.amount"),
      width: 80,
      maxWidth: 80,
      ellipsis: true,
      render: (text: string, record: any, index: string) => {
        let amountData
        let decimalPart = text && text.toString().split('.')[1]
        if (text !== '' && text !== undefined && text !== ' ') {
          amountData =
            !isNaN(text) &&
              text !== '' &&
              ((decimalPart && decimalPart.length < 3) || !decimalPart) ? (
              <div className={Number(text) < 0 ? "editble-cell-value-wrap editable-cell-value-wrap__salary isRedAmount" : "editble-cell-value-wrap editable-cell-value-wrap__salary"} style={{width: "80px"}}>
                {financial(text)}
              </div>
            ) : (
              <div
                // style={{ maxWidth: 120 }}
                className="editable-cell-value-wrap--errored editable-cell-value-wrap--errored__salary"
                style={{width: "80px"}}
              >
                <p className={Number(text) < 0 ? "isRedAmount" : ""} style={{width: "100%"}}>{text !== '' ? text : ''}</p>
              </div>
            )
          return amountData
        } else {
          return (
            <div className="editable-cell-value-wrap__added editable-form-item__added" >
              <p className="editable-form-item__input editable-form-item__input--bordered">
                <p className="child_placeholder" >
                  {t("common.amount")}
                </p>
                {text}
              </p>
              {/*<EditIco />*/}
            </div>
          )
        }
      },
      sorter: (a: object, b: object) => a.text - b.text,
    },
    // {
    //   title: (
    //       <div className="searchable-column">
    //         <div className={'flex transferSorter'}>
    //           <Form form={form} className={"transfer-form"}>
    //             <SearchableColumn
    //               large
    //               title={t("transfers.details")}
    //               form={form}
    //               name={'description'}
    //               filter={'searchfilter'}
    //               onChange={(event: any) =>
    //                 handleFilterColumn(event, 'description')
    //               }
    //             />
    //           </Form>
    //           {/* <SearchableColumn title={t("transfers.details")} /> */}
    //         </div>
    //       </div>
    //   ),
    //   dataIndex: 'description',
    //   key: 'description',
    //   editable: true,
    //   placeholder: t("transfers.details"),
    //   width: 400,
    //   ellipsis: true,
    //   render: (text: string, record: any, index: string) => {
    //     // onlyLetters(text)
    //     if (text !== '' && text !== undefined) {
    //       return text ? (
    //         <div
    //           className={
    //             (text && text.length > 140) ||
    //               specialCharRegexRu.test(text) ||
    //               specialCharRegex.test(text)
    //               ? 'editable-cell-value-wrap--errored editable-cell-value-wrap--errored__salary'
    //               : 'editable-cell-value-wrap editable-cell-value-wrap__salary'
    //           }
    //         >
    //           {' '}
    //           {text?.length > 17 ? (
    //             <CustomTooltip title={text}>
    //               <p>{text}</p>
    //             </CustomTooltip>
    //           ) : (
    //             <p>{text}</p>
    //           )}
    //         </div>
    //       ) : (
    //         <div className="editable-cell-value-wrap--errored editable-cell-value-wrap--errored__salary">
    //           {text?.length > 17 ? (
    //             <CustomTooltip title={text}>
    //               <p>{text}</p>
    //             </CustomTooltip>
    //           ) : (
    //             <p>{text}</p>
    //           )}
    //         </div>
    //       )
    //     } else {
    //       return (
    //         <div className="editable-cell-value-wrap__added editable-form-item__added">
    //           <p className="editable-form-item__input editable-form-item__input--bordered">
    //             <p className="child_placeholder">{t("transfers.details")}</p>
    //             {text}
    //           </p>
    //           <EditIco />
    //         </div>
    //       )
    //     }
    //   },
    // },
    {
      title: (
        <div className="flex ant-table-column-title" style={{ paddingLeft: '30px'}}>
          {t("newTransfer.note")}
          <CustomTooltip title={t("newTransfer.notTransferableToBank")}>
            <Button
              type={'ghost'}
              className={'transparent'}
              style={{ margin: 'auto' }}
              icon={<TabsInfoIco />}
            />
          </CustomTooltip>
        </div>
      ),
      dataIndex: 'notification',
      key: 'notification',
      width: 40,
      ellipsis: true,
      editable: false,
      render: (text: string, record: any) => {
        return text ? (
          <CustomTooltip title={record.notification}>
            <Button onClick={() => handleNotChange(record, text)}>
              {specialCharRegex.test(text) ? (
                <NoticeLineReddIco />
              ) : (
                <NoticeLinedIco />
              )}
            </Button>
          </CustomTooltip>
        ) : (
          <Button onClick={() => handleNotChange(record, text)}>
            <NoticeIco />
          </Button>
        )
      },
    },
    {
      title: (
        <>
          <p
            style={{
              textAlign: 'left',
              color: '#747a83',
              fontSize: '12px',
              position: 'absolute',
              left: 29,
              zIndex: 9,
              top: -1,
              paddingLeft: '30px',
            }}
          >
            Status
          </p>
          <Form form={form}>
            <SelectField
              placeholder={t("common.all")}
              label
              defaultValue="all"
              options={statusOptions}
              dropdownClassName="salary-select"
              className="filter-select salary-select"
              name={'status_filter'}
              onChange={(value: any) => handleStatusFilter(value)}
            />
          </Form>
        </>
      ),
      dataIndex: 'status',
      key: 'status',
      editable: false,
      width: 100,
      ellipsis: true,
      render: (text: any, record: any, index: any) => {
        switch (status) {
          case 'checked':
            return (
              <div className="flex status-icons">
                <CustomTooltip title={t("salary.accountVerification")}>
                  {checkResultSuccess.length > 0 && <img src={successStatus} />}
                </CustomTooltip>
              </div>
            )
          case 'errored':
            return (
              <div className="flex status-icons">
                {checkResult.length > 0 && <img src={errorStatus} />}
              </div>
            )
          case 'all':
            return (
              <div className="flex status-icons">
                {checkResultData.length > 0 &&
                  checkResultData.map((e, index) => {
                    if (e.EMPLACC == record.account) {
                      return (
                        <CustomTooltip title={`${e.ERROR_TEXT_AZE}`}>
                          <img src={errorStatus} />
                        </CustomTooltip>
                      )
                    }
                  })}
                {checkResultSuccess.length > 0 &&
                  checkResultSuccess.some((e) => e === record.account) && (
                    <CustomTooltip title={t("salary.accountVerification")}>
                      <img src={successStatus} />
                    </CustomTooltip>
                  )}
                {repeatAcc.length > 0 &&
                  //@ts-ignore
                  repeatAcc.some((e) => e.account === record.account) && (
                    <CustomTooltip title={t("salary.accountDuplicated")}>
                      <img
                        src={checkedStatus}
                        style={{ position: 'relative', left: 18 }}
                      />
                    </CustomTooltip>
                  )}
              </div>
            )
          default:
            return (
              <div className="flex status-icons">
                {checkResultData.length > 0 &&
                  checkResultData.map((e) => {
                    if (e.EMPLACC == record.account) {
                      return (
                        <CustomTooltip title={`${e.ERROR_TEXT_AZE}`}>
                          <img src={errorStatus} />
                        </CustomTooltip>
                      )
                    }
                  })}
                {checkResultSuccess.length > 0 &&
                  checkResultSuccess.some((e) => e === record.account) && (
                    <CustomTooltip title={t("salary.accountVerification")}>
                      <img src={successStatus} />
                    </CustomTooltip>
                  )}
                {repeatAcc.length > 0 &&
                  //@ts-ignore
                  repeatAcc.some((e) => e.account === record.account) && (
                    <CustomTooltip title={t("salary.accountDuplicated")}>
                      <img
                        src={checkedStatus}
                        style={{ position: 'relative', left: 18 }}
                      />
                    </CustomTooltip>
                  )}
              </div>
            )
        }
      },
    },
  ]

  const validateItem = (data: any) => {
    let errAccIndex: Array<any> = []
    let errAmIndex: Array<any> = []
    let errDescIndex: Array<any> = []
    let errIndexLocal: Array<any> = []
    let errNotification: Array<any> = []

    const repeatAcc = data.reduce((a: any, e: any) => {
      a[e.account] = ++a[e.account] || 0
      return a
    }, {})

    setRepeatAccount(data.filter((e: any) => repeatAcc[e.account]))
    const filteredAccount = data.filter((row: any) => {
      if (
        (row['account'] &&
          (!row['account'].includes('BRES') || row['account'].length !== 28)) ||
        !row['account']
      ) {
        errAccIndex.push(row.account)
        return errAccIndex
      }
    })
    // setErrAccounts(filteredAccount)

    const filteredAmount = data.filter((row: any) => {
      let decimal = row.amount && row.amount.toString().split('.')[1]
      if (isNaN(row.amount) || (decimal && decimal.length > 2) || !row.amount || (Number(row.amount) < 0)) {
        errIndexLocal.push(row['account'])
        return errAmIndex
      }
    })
    // setAmountWithErr(filteredAmount)

    // const filteredDesc = data.filter((item: any) => {
    //   if (
    //     (item.description &&
    //       (item.description.length > 140 ||
    //         item.description == '' ||
    //         specialCharRegexRu.test(item.description))) ||
    //     !item.description
    //   ) {
    //     errDescIndex.push(item['account'])
    //     return errDescIndex
    //   }
    // })

    let joinedArr = [
      ...filteredAccount,
      ...filteredAmount,
      // ...filteredDesc,
      ...errNotification,
    ]
    var unique = joinedArr.filter((v, i, a) => a.indexOf(v) === i)
    //@ts-ignore
    setErroredIndex(unique)
    return unique
    // setDescWithErr(filteredDesc)
  }

  useEffect(() => {
    if (editedTableValue.length > 0) {
      validateItem(editedTableValue)
    }
    setIsChecked(false)
  }, [editedTableValue])


  useEffect(() => {
    if (!form.getFieldValue('COMMISSION') || !form.getFieldValue('MAINDET')) {
      setHasError(true)
    } else {
      setHasError(false)
    }
  }, [form.getFieldValue('COMMISSION'),form.getFieldValue('MAINDET')])

  const handleStatusFilter = (value: string) => {
    if (value == 'checked') {
      setIsFiltered(true)
      let resChecked = editedTableValue.filter(
        (item: any) => !checkResult.some((e) => e === item.account)
      )
      setFilteredData(resChecked)
      setFilteredDataForSort(resChecked)
    } else if (value == 'errored') {
      setIsFiltered(true)
      let resErrored = editedTableValue.filter((item: any) =>
        checkResult.some((e) => e === item.account)
      )
      let resErroredIndex = editedTableValue.filter((item: any) =>
        erroredIndex.some((e) => e.number === item.number)
      )
      const join = [...resErrored, ...resErroredIndex]
      setFilteredData(join)
      setFilteredDataForSort(join)
    } else {
      // setFilteredData(editedTableValue)
      setIsFiltered(false)
    }
    setStatus(value)
  }

  const submitHandler = (args: any) => {
    let amount = financial(form.getFieldValue('PMTAMOUNT'))
    let pdf_files = form.getFieldValue('pdf_files') ?? []
    modalDataInitial.pdfFiles = []
    if (pdf_files.length > 0) {
      for (let file of pdf_files) {
        modalDataInitial.pdfFiles.push({
          label: file.name,
          file: file,
        })
      }
    }
    let detail= form.getFieldValue('PMTDETAIL') !== undefined ? form.getFieldValue('PMTDETAIL'):''
   
    //@ts-ignore
    setModalData((old_data: any) => ({
      ...modalDataInitial,
      groups: [
        {
          tableHasBorderBottom: false,
          tableHasBorderBottom2: true,
          title: false,
          data: [
            {
              label: t("transfers.sender"),
              value: getCurrentCompany().name,
            },
            {
              label: t("salary.documentNo"),
              value: form.getFieldValue('PMTCUSTID'),
            },
            {
              label: t("transfers.fromAccount"),
              value: form.getFieldValue('CUSTACC') + ' AZN',
            },
            {
              label: t("common.amount"),
              value: amount + ' AZN',
            },
            {
              label: t("home.commission"),
              value: form.getFieldValue('COMMISSION') + ' AZN',
            },
            {
              label: t("salary.toAccount"),
              value: form.getFieldValue('CUSTACCTO'),
            },{
              label: t("accountStatement.paymentDetails"),
              value: form.getFieldValue('MAINDET') + " " + detail,
            },
            form.getFieldValue('NOTE') !== undefined && form.getFieldValue('NOTE') !== '' ? {
              label: t("newTransfer.note"),
              value: form.getFieldValue('NOTE'),
            } : undefined,
          ],
        },
      ],
    }))
    setNextModalVisible((old_data) => true)
   
  }

  const handleReset = (args: string) => {
    // form.setFieldsValue({'CUSTACC': ''})
    if (args === 'reset') {
      form.resetFields()
    }
    setNotice(undefined)
    setDefaultNote('')
    setCurrent(1)
    setCurrent(1)
    setAdded(false)
    setSymbolCount(180)
    editTableDataSalary([])
    setCheckResult([])
    setCheckResultSuccess([])
    setCheckedList([])
    setErrorCount([])
    setEmployeData([])
    setErroredIndex([])
  }

  const handleFormChange = () => {
    const hasErrors = form.getFieldsError().some(({ errors }) => errors.length)
  }

  const handleAddRow = () => {
    setCurrent(tableData.length)
    setAdded(true)
    const newColumn = {
      number:
        editedTableValue.length !== 0
          ? editedTableValue.at(-1)
            ? editedTableValue.at(-1).number + 1
            : editedTableValue.length + 1
          : 1,
      key:
        editedTableValue.length !== 0
          ? editedTableValue.at(-1)
            ? editedTableValue.at(-1).number + 1
            : editedTableValue.length + 1
          : 1,
      name: '',
      owner: '',
      account: '',
      amount: '',
      description: '',
      notification: '',
      status: 'all',
    }
    // editTableDataSalary(temp_array)
    const newData = [...editedTableValue]
    newData.push(newColumn)
    // if (editedTableValue.length == 0) {
    setTableDataSalary(newData)
    // }
    editTableDataSalary(newData)
  }

  useEffect(() => {
    if (createdTransferValue.length !== 0) {
      const newData:any = []
      createdTransferValue?.map((item: any, index: number) => {
        setCurrent(tableData.length)
        setAdded(true)
        const newColumn = {
          number:
            index + 1,
          key:
            index + 1,
          name: '',
          owner: item.owner,
          account: item.iban,
          amount: item.amount,
          description: item.description,
          notification: '',
          status: 'all',
        }

        newData.push(newColumn)

      })
      setTableDataSalary(newData)
      // }
      editTableDataSalary(newData)
      createTransferSalary([])
    }

  }, [createdTransferValue])

  useEffect(() => {
    // editTableDataSalary([])
    loadData()
    
    if (location?.state?.data) {
      if (location?.state?.data?.TRANSACTION_EMPLIST?.length !== 0) {

        const newData = []

        location?.state?.data?.TRANSACTION_EMPLIST?.map((item: any, index: number) => {
          setCurrent(tableData.length)
          setAdded(true)
          const newColumn = {
            number:
              index + 1,
            key:
              index + 1,
            name: '',
            owner: item.owner,
            account: item.employeeAccount,
            amount: item.employeeAmount,
            description: item.employeePmtDetail,
            notification: '',
            status: 'all',
          }

          newData.push(newColumn)

        })
        setTableDataSalary(newData)
        editTableDataSalary(newData)
      }
     
    }

    if (location.state) {
      window.history.replaceState({}, '', location.pathname);
    }

  }, [location.state])

  useEffect(()=>{
    
    console.log(editedTableValue)
    
  },[])

  const loadData = async () => {

    const data = await getAccounts(getCurrentCompany())
    let temp_data: Array<any> = []
    for (let row of data) {
      // @ts-ignore
      if (row.CCY_NAME == 'AZN' && row.STATUS !== '0' && row?.PRODUCT_CODE !== "140110" && row?.PRODUCT_CODE !== "140111") {
        temp_data.push({
          label: row.NICKNAME ? row.NICKNAME : row.IBAN,
          value: row.IBAN,
          extra: `${financial(row.BALANCE_LC) ? financial(row.BALANCE_LC) : ''
          } ${row.CCY_NAME}`,
        })
      }
    }
    setAllAccounts(data)
    setFromSelectOptions((old_data) => temp_data)

    if(location.state?.edit)
      setIbankRef(location.state?.data['ibankRef'])
    // CUSTACC
    const findAccount = data?.find(row => row.IBAN == location.state?.data['CUSTACC'] && row.STATUS !== "0");
    if (findAccount !== undefined) {
      setFromBranch(findAccount);
      if ((form.getFieldValue('PMTCUSTID') === "" || form.getFieldValue('PMTCUSTID') === undefined) && location.state?.edit === undefined) {
        updateDocumentNumber();
      } else if (location.state?.edit) {
        form.setFieldsValue({
          'PMTCUSTID': location.state?.data['PMTCUSTID']
        });
      }

      form.setFieldsValue({
        'CUSTACC': location.state?.data['CUSTACC']
      });
    }


    //NOTE
    form.setFieldsValue({
      'NOTE': location.state?.data['NOTE']
    });

    // PMTDETAIL
  

    if(location.state?.data['mainDetail']===undefined){
      setMainDet('')
    
      form.setFieldsValue({
        'MAINDET': undefined
      });

    }else {
      form.setFieldsValue({
        'MAINDET': location.state?.data['mainDetail']
      });
      setMainDet(location.state?.data['mainDetail'])
    }
   

    if (location.state?.data['PMTDETAIL'].includes(location.state?.data['mainDetail'])) {
      const PMTDETAILWithoutMainDet = location.state?.data['PMTDETAIL'].replace(location.state?.data['mainDetail'], '').trim();
      form.setFieldsValue({
        'PMTDETAIL': PMTDETAILWithoutMainDet
      });
    } else {
      form.setFieldsValue({
        'PMTDETAIL': location.state?.data['PMTDETAIL']
      });}
  }

  function onSelectChange(checkedList: Array<String>) {
    //@ts-ignore
    setCheckedList(checkedList)
  }

  function onSelectAll(selectAll: Array<String>) {
    let data = isFilterd ? filteredData : editedTableValue
    if (selectAll) {
      let allSelctedArray: Array<any> = []
      data.map((item: any) => {
        allSelctedArray.push(item.key)
        setCheckedList(allSelctedArray)
      })
    } else {
      setCheckedList([])
    }

    //@ts-ignore
  }

  const checkSalary = async () => {
    setShowSpinner(true)
    let accArr: Array<any> = []
    editedTableValue.map((item: any) => {
      accArr.push(item.account)
    })
    let postData = {
      COMPCIF: getCurrentCompany().customerNo,
      EMPLACC: accArr,

    }
    let errArr: Array<any> = []
    let successArr: Array<any> = []
    const data = await checkSalaryList(postData)
    setIsChecked(true)
    //@ts-ignore
    data.TRANZITACC !== null &&
      data.EMPLOYEE.map((item: any) => {
        if (item.ERROR_CODE != 0) {
          errArr.push(item.EMPLACC)
        }
        if (item.ERROR_CODE == 0) {
          successArr.push(item.EMPLACC)
        }
        const geterrMessages = data.EMPLOYEE.filter((item: any, i: number) => {
          return item.ERROR_CODE != 0
        })

        const filteredData = geterrMessages.filter(
          (value, index, self) =>
            self.findIndex((v) => v.EMPLACC === value.EMPLACC) === index
        )
        setCheckResultData(filteredData)
      })
    const filteredIndex: Array<any> = []
    const filteredArray = editedTableValue.filter((value: any) =>
      errArr.includes(value.account)
    )
    filteredArray.map((item: any) => {
      filteredIndex.push(item.number)
    })
    let validationResult = await validateItem(editedTableValue)

    const errAcc: Array<any> = []
    validationResult.map((item) => {
      return errAcc.push(item.number)
    })

    const errorSum = [...errAcc, ...filteredIndex]

    var errorSumUnique = errorSum.filter((v, i, a) => a.indexOf(v) === i)
    setErrorCount(errorSumUnique)
    //@ts-ignore
    setCheckResult(errArr)
    setCheckResultSuccess(successArr)
    setEmployeData(data.EMPLOYEE)
    if (errArr.length === 0 && data.TRANZITACC && data.TRANZITACC !== '') {
      setCheckError(false)
    }
    setShowSpinner(false)
  }

  const handleRemoveRow = () => {
    let removedArrFiltered: Array<number> = []
    const removedArr = editedTableValue.filter(
      (item: number) => !selectedRowKeys.includes(item.number)
    )
    if (isFilterd) {
      removedArrFiltered = filteredData.filter(
        (item: number) => !selectedRowKeys.includes(item.number)
      )
      setFilteredData(removedArrFiltered)
      setFilteredDataForSort(removedArrFiltered)
    }
    const errArr: Array<any> = []
    removedArr.map((item: any) => {
      if (errorCount.includes(item.number)) {
        errArr.push(item.number)
      }
    })
    const removedArrayIndexed = removedArr.map((item: any, index: number) => {
      return { ...item, key: index + 1, number: index + 1 }
    })
    if (
      (isFilterd && removedArrFiltered.length == 0) ||
      (!isFilterd && removedArr.length == 0)
    ) {
      handleReset('file')
    }
    setErrorCount(errArr)
    editTableDataSalary(removedArrayIndexed)
    setCheckedList([])
  }

  const updateCounter = () => {
    let symbol_count = 180 - notice?.length
    setSymbolCount(() => (!isNaN(symbol_count) ? symbol_count : 180))
    // setMaxRows(old_value => calc_row);
  }

  const onKeyPress = (e: React.KeyboardEvent) => {
    const pressedKey = String.fromCharCode(!e.charCode ? e.which : e.charCode)
    if (specialCharRegex.test(pressedKey)) {
      e.preventDefault()
      return false
    } else {
      updateCounter()
    }
  }

  const handleCellSave = (text: string, record: any) => {
    setNewRecord('')
    if (text !== undefined || text !== '' || !record.description) {
      const newData = [...editedTableValue]
      const index = newData.findIndex((item) => record.key === item.key)
      const item = newData[index]
      newData.splice(index, 1, { ...item, ...{ [`${text}`]: newRecord } })
      editTableDataSalary(newData)
    }
    //setir bosh deyilse yadda saxlasin
  }

  const handleInputChangeSave = (row: any) => {
    const newData = [...editedTableValue]
    if (paste) {
      const index = newData.findIndex((item) => row.key === item.key)
      const item = newData[index]
      newData.splice(index, 1, { ...item, ...row })
    }
    editTableDataSalary(newData)

    if (isFilterd) {
      const newDataFiltered = [...filteredData]
      if (paste) {
        const index = newDataFiltered.findIndex((item) => row.key === item.key)
        const item = newDataFiltered[index]
        newDataFiltered.splice(index, 1, { ...item, ...row })
      }
      setFilteredData(newDataFiltered)
      setFilteredDataForSort(newDataFiltered)
    }
  }

  const handleInputChange = (e: any, dataIndex: string) => {
    setCopiedData(e.target.value)
  }

  const allRowKeys = (isFilterd ? filteredData : editedTableValue).map(
  (item: any) => item.key
);

const rowSelection = {
  selectedRowKeys,
  onChange: (keys: React.Key[]) => {
    setCheckedList(keys);
  },
  columnTitle: (
    <Checkbox
      indeterminate={
        selectedRowKeys.length > 0 &&
        selectedRowKeys.length < allRowKeys.length
      }
      checked={
        allRowKeys.length > 0 &&
        selectedRowKeys.length === allRowKeys.length
      }
      disabled={allRowKeys.length === 0}
      onChange={(e) => {
        if (e.target.checked) {
          setCheckedList(allRowKeys);
        } else {
          setCheckedList([]);
        }
      }}
    />
  ),
  columnWidth: 20,
};
  return (
    <div className='transfer_child_tabs' ref={ref}>
      {showSpinner && <FullScreenLoading />}
      {textAreaModal && (
        <Modal
          width={530}
          height={260}
          visible={textAreaModal}
          title={t("salary.editingNote")}
          className="warning-modal notification-modal edit-modal"
          onOk={handleTextEdit}
          onCancel={() => setTextVisibleModal(false)}
        >
          <div className={'label_div'}>
          <label>{t("newTransfer.note")}</label>
          </div>
          <Form>
            <Form.Item className={`input-field text_area`}>
              <TextArea
                placeholder=""
                showCount={false}
                name={'NOTE'}
                defaultValue={defaultNote}
                maxLength={180}
                size="small"
                // onPaste={(e) => onPasteText(e)}
                autoSize={{ minRows: 2, maxRows: 4 }}
                onKeyUp={(e) => onKeyPress(e)}
                onKeyPress={(e) => onKeyPress(e)}
                className="custom_input_component custom_textarea_component edit_textarea_component"
                onChange={(e: any) => handleTextAreaChange(e)}
                style={{
                  width: '471px',
                  display: 'block',
                  height: 80,
                  margin: 'auto auto 0px auto',
                  zIndex: '9999',
                  position: 'relative',
                }}
              // required={true}
              />
              <div className={'show_symbol_count'}>
                <span>
                  {defaultNote && defaultNote.length ? symbolCount : 180}
                </span>
                /180
              </div>
            </Form.Item>
          </Form>
        </Modal>
      )}
      <Col span={24} style={{ backgroundColor: '#fff' }}>
        <TransferInputs
          form={form}
          onFinish={checkSalary}
          checkSalaryData={checkSalary}
          newTransferFunc={newTransferFunc}
          employeData={employeData}
          onFieldsChange={handleFormChange}
          removeFile={() => handleReset('file')}
          maindet={maindet}
          //@ts-ignore
          getSelectedFromBranch={getSelectedFromBranch}
          fromBranch={fromBranch}
          modalData={modalData}
          nextModalVisible={nextModalVisible}
          setNextModalVisible={setNextModalVisible}
          fromSelectOptions={fromSelectOptions}
          documentNumber={documentNumber}
        />
        <Col flex={'900px'} className="salary-transfer__table__divider">
          <div className="salary-transfer__table">
            <Row style={{ justifyContent: 'space-between' }}>
              <ul className="d-flex">
                <li>
                  {t("salary.totalRows")}{' '}
                  <span className="success-count">
                    {editedTableValue.length}
                  </span>
                </li>
                <li>
                  {t("salary.countErrorRows")}{' '}
                  <span className="error-count">
                    {checkResult.length == 0 && checkResultSuccess.length == 0
                      ? erroredIndex.length
                      : errorCount.length > erroredIndex.length
                        ? errorCount.length
                        : erroredIndex.length}
                  </span>
                </li>
              </ul>
              <div className="flex pagination-selector">
                <p>{t("salary.numberAtPage")} </p>
                <Select
                  defaultValue={10}
                  onChange={(value) => setPageSize(value)}
                >
                  {pageOptions.map((item) => {
                    return <option value={item}>{item}</option>
                  })}
                </Select>
              </div>
            </Row>
          </div>
          <TableComponent
            // className="transfer-table salary-table"
            className={`table-empty transfer-table--mass transfer-table transfers-table__component  salary-table  home_account_table ${editedTableValue.length == 0 && 'salary-empty'
              }`}
            // handleCellSave={handleCellSave}
            handleInputChange={(e: any, dataIndex: string) =>
              handleInputChange(e, dataIndex)
            }
            handleInputChangeSave={handleInputChangeSave}
            columns={columnsData}
            handleAddRow={handleAddRow}
            handleRemoveRow={handleRemoveRow}
            id={'salary-table'}
            
            // readOnly={!paste}
            // onPaste={!paste ?  onPasteText() : onPasteTextTrue()}
            onPageChange={(page: number) => setCurrent(page)}
            current={current}
            disableRemove={selectedRowKeys.length == 0}
            disableAdd={
              !form.getFieldValue('PMTCUSTID') || !form.getFieldValue('CUSTACC')
            }
            scroll={{ x: true, sticky: true }}
            rowSelection={rowSelection}
            editableRows={true}
            // editableRows={form.getFieldValue('CUSTACC') ? true : false}
            data={isFilterd ? filteredData : editedTableValue}
            pagination={true}
            pageSize={pageSize}
          />
        </Col>
        <TransferBottom
          // hasErrorAcc={erroredIndex.length > 0 || hasErrorForm || !form.getFieldValue('PMTDETAIL') || !checkError}
          hasErrorAcc={editedTableValue.length == 0 || validateAccount(editedTableValue).length}
          hasError={
            checkError ||
            !isChekded ||
            errorCount.length > 0 ||
            erroredIndex.length > 0 ||
            editedTableValue.length == 0 || hasError
          }
          handleSalarySubmit={submitHandler}
          handleReset={() => handleReset('reset')}
          tableValue={editedTableValue}
          checkSalary={() => checkSalary()}
        />
      </Col>
      {/* </Spin> */}
    </div>
  )
}
const mapStateToProps = (state: any) => ({
  tableData: state.salary.tableValue ? state.salary.tableValue : '',
  account: state.salary.selectedItem,
  tableValue: state.salary.tableValue,
  editedTableValue: state.salary.editedTableValue,
  companyData: state.user.isCompChange ? state.user.isCompChange : false,
  createdTransferValue: state.salary.createdTransferValue,
})
const mapDispatchToProps = {
  setTableDataSalary,
  setSelectedOption,
  editTableDataSalary,
  createTransferSalary
}

export default connect(mapStateToProps, mapDispatchToProps)(Transfer)
